import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectsStyleByRecord } from 'PDF/helpers/documentStyle';

import { List } from '../List/List';

export interface IRowItem {
  pointName: string;
  iconSrc: string;
  items: string[][];
}

interface ITableRowsProps {
  rows: IRowItem[];
  firstCeilWidth: string;
  ceilWidth: string;
  noCapturedFirstColumn?: boolean;
}

const colorIndexes = {
  green: [2, 12, 7],
  blue: [2, 5, 0],
  red: [2, 5, 1],
  blueGreen: [2, 38, 0],
  blueRed: [2, 38, 5],
  blueYellow: [2, 38, 5],
};

export const TableRows = ({ rows, firstCeilWidth, ceilWidth, noCapturedFirstColumn }: ITableRowsProps) => {
  const [backgroundColor, color, dotsColor] = getColorObjectsStyleByRecord(colorIndexes, [
    'backgroundColor',
    'color',
    'color',
  ]);

  return (
    <View style={[styles.rowsContainer, backgroundColor]}>
      {rows.map(({ iconSrc, pointName, items }) => {
        return (
          <View key={pointName} style={styles.pointRow}>
            <View style={[styles.headingWrap, { width: firstCeilWidth }]}>
              <Image src={iconSrc} style={styles.icon} />
              <Text style={[styles.heading, color]}>{pointName}</Text>
            </View>
            {items.map((list, index) => {
              const whiteBackground = list.length > 0 && index === 0 && !noCapturedFirstColumn;

              return (
                <View
                  key={index}
                  style={[
                    styles.infoCeil,
                    {
                      width: ceilWidth,
                      paddingBottom: index === items.length - 1 ? 5 : 10,
                      backgroundColor: whiteBackground ? '#fff' : 'transparent',
                      paddingRight: 12,
                    },
                  ]}
                >
                  <List steps={list} noPadding color={dotsColor} />
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  rowsContainer: {
    paddingVertical: 5,
  },
  pointRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginTop: '-1px',
  },
  headingWrap: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    paddingTop: 5,
  },
  icon: {
    width: '13px',
    height: '13px',
    marginLeft: '7px',
    marginRight: '5px',
  },
  heading: {
    fontFamily: 'Noto',
    fontWeight: 500,
    fontSize: '9px',
    lineHeight: 1.3,
  },
  infoCeil: {
    paddingTop: 5,
    paddingHorizontal: 4,
    marginLeft: 5,
  },
});
